export default {"src":"/_next/static/media/galleries.44afc291.svg","height":36,"width":36};